import { create } from 'zustand';

import { registerWorkspaceReset } from '@/lib/workspace/workspaceResetRegistry';

interface WorkflowLibraryStore {
  isOpen: boolean;
  projectId: string | null;
  open: (projectId: string) => void;
  close: () => void;
}

export const useWorkflowLibraryStore = create<WorkflowLibraryStore>((set) => ({
  isOpen: false,
  projectId: null,
  open: (projectId) => set({ isOpen: true, projectId }),
  close: () => set({ isOpen: false, projectId: null }),
}));

registerWorkspaceReset('workflow-library-store', () => {
  useWorkflowLibraryStore.setState({ isOpen: false, projectId: null });
});

if (typeof window !== 'undefined') {
  (window as any).__useWorkflowLibraryStore = useWorkflowLibraryStore;
}
